import { render, staticRenderFns } from "./TireRegisterInputInfo.vue?vue&type=template&id=b580b7be&scoped=true"
import script from "./TireRegisterInputInfo.vue?vue&type=script&lang=ts"
export * from "./TireRegisterInputInfo.vue?vue&type=script&lang=ts"
import style0 from "./TireRegisterInputInfo.vue?vue&type=style&index=0&id=b580b7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b580b7be",
  null
  
)

export default component.exports